export const COMPONENT_NAME = 'TripAdvisor';
